import { defineComponent as _defineComponent } from 'vue'
import Icon from "@/components/widgets/icons/Icon.vue"
import { MissionStaffingPositionBasicFragmentFragment } from "@/gql"
import { useAuth } from "@/store/auth/useAuth"
import { computed } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'OpenRolesCard',
  props: {
    openRoles: null
  },
  setup(__props: any) {

const props = __props as {
  openRoles: MissionStaffingPositionBasicFragmentFragment[]
}



const { getUser } = useAuth()

const user = computed(() => getUser())

const hasTwoOrMoreRoles = computed(() =>
  props.openRoles.length - 2 > 0 ? props.openRoles.length - 2 : 0
)

return { __sfc: true,props, getUser, user, hasTwoOrMoreRoles, Icon }
}

})